import React, { useRef, useState, useEffect } from 'react';
import { Typography, Button, message, Card, Flex, Image } from 'antd';
import GoldImageCapture from './GoldImageCapture';
import { CameraOutlined } from '@ant-design/icons';
import { uploadRawImage, updateCustomerPhoto } from '../api';

const { Title, Text } = Typography;

const CustomerDetails = ({ customer = {}, billData = {}, onImageChange, images = [], setImages, customerImage, setCustomerImage }) => {
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(customer.photo || '');

  useEffect(() => {
    setPreview(customer.photo || '');
  }, [customer.photo]);

  const handleClick = () => {
    if (fileRef.current) fileRef.current.click();
  };

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    try {
      // Upload the image
      const dateStr = new Date().toISOString().split('T')[0];
      const fileName = `${customer._id}_photo_${dateStr}.jpg`;
      const folderId = 'customer_photos';

      console.log('[CustomerDetails] Uploading customer photo:', fileName);
      const uploadResponse = await uploadRawImage(file, { fileName, folderId });

      if (!uploadResponse.success || !uploadResponse.data) {
        throw new Error(uploadResponse.message || 'Upload failed');
      }

      const uploadedData = uploadResponse.data;

      // Update customer photo in DB
      console.log('[CustomerDetails] Updating customer photo in DB');
      await updateCustomerPhoto(customer._id, uploadedData);

      // Set preview
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
        // Update customerImage in bill
        if (setCustomerImage) setCustomerImage(uploadedData);
        // Call onImageChange if needed
        if (onImageChange) onImageChange({ file, dataUrl: reader.result, uploadedData });
      };
      reader.readAsDataURL(file);

      message.success('Customer photo uploaded and updated successfully');
    } catch (error) {
      console.error('Customer photo upload failed:', error);
      message.error(error.message || 'Failed to upload customer photo');
    }

    e.target.value = '';
  };

  const initials = (customer.name || '')
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div style={{ marginBottom: '20px', display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />

        <div style={{ position: 'relative' }}>
          <div
            onClick={handleClick}
            role="button"
            tabIndex={0}
            style={{
              width: 200,
              height: 200,
              borderRadius: 8,
              overflow: 'hidden',
              cursor: 'pointer',
              border: '1px solid #e8e8e8',
              background: '#fafafa',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              color: '#666',
            }}
          >
            {preview ? (
              <img src={preview} alt="customer" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            ) : (
              <div style={{ textAlign: 'center' }}>{initials || <CameraOutlined />}</div>
            )}
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <Title level={5}>Customer Details</Title>

          <Text style={{ fontSize: 14, lineHeight: 1.6, display: 'block' }}>
            <strong>Name: </strong> {customer.name}
          </Text>
          <Text style={{ fontSize: 14, lineHeight: 1.6, display: 'block' }}>
            <strong>Phone: </strong> {customer.phone}
          </Text>
          <Text style={{ fontSize: 14, lineHeight: 1.6, display: 'block' }}>
            <strong>Email: </strong> {customer.email}
          </Text>
          <Text style={{ fontSize: 14, lineHeight: 1.6, display: 'block' }}>
            <strong>Address: </strong> {customer.address}
          </Text>
        </div>
      </div>

      {/* GoldImageCapture placed inside CustomerDetails for side-by-side layout */}
      <div style={{ marginLeft: 12 }}>


        {billData?.images && billData.images.length > 0 && (
           <Flex gap={12} wrap="wrap">
              {billData.images.map((img, idx) => (
                <Image
                    src={img.thumbnailUrl || img.url}
                    alt={img.name || `Gold image ${idx + 1}`}
                  
                    style={{
                       width: 200,
                       height: 200,
                      objectFit: 'fill',
                      display: 'block'
                    }}
                    preview={false}
                  />
              ))}
            </Flex>
        )}
      </div>


    </div>
  );
};

export default CustomerDetails;
